module.exports = __webpack_public_path__ + "img/22.b25f4f39.jpg";